// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fonts */
:root {
  --font-default: "Poppins", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    "Noto Color Emoji";
  --font-primary: "Poppins", sans-serif;
  --font-secondary: "Montserrat", sans-serif;
}

/* Colors */
/* Default (Light Mode) */
:root {
  --color-default: #222222;
  --color-primary: #5cc180;
  --color-primary-transparent: #5cc18090;
  --color-secondary: #f85a40;
  --color-third: #2a6620;
  --color-white: #fefefe;
  --background-color: #fcfdff;
  --background-color-transparent: #2e2e2e90;
  --text-color: #18063c;
  --text-darkblue: #18063c;
  --text-pure-white: #fefefe;
  --navbar-bg-color: #fefefe;
  --footer-bg-color: #5cc180;
  --custom-card1: #a6dbb7;
  --custom-card2: #5cc180;
  --custom-card3: #5bc17f4f;
  --icon-color-1: #f44336; /* Red */
  --icon-color-2: #9c27b0; /* Purple */
  --icon-color-3: #3f51b5; /* Indigo */
  --icon-color-4: #4caf50; /* Green */
  --icon-color-5: #ff9800; /* Orange */
  --icon-color-6: #795548; /* Brown */
}

/* Dark Mode */
body.dark-mode {
  --color-default: #fefefe;
  --color-primary: #5cc180;
  --color-primary-transparent: #fefefe90;
  --color-secondary: #f85a40;
  --color-third: #203366;
  --color-white: #222222;
  --background-color: #111827;
  --background-color-transparent: #fefefe90;
  --text-color: #fefefe;
  --text-darkblue: #fefefe;
  --navbar-bg-color: #1f2937;
  --footer-bg-color: #1f2937;
  --custom-card1: #1f2937;
  --custom-card2: #111827;
  --custom-card3: transparent;
  --icon-color-1: #f44336; /* Red */
  --icon-color-2: #9c27b0; /* Purple */
  --icon-color-3: #3f51b5; /* Indigo */
  --icon-color-4: #4caf50; /* Green */
  --icon-color-5: #ff9800; /* Orange */
  --icon-color-6: #795548; /* Brown */
}

/* Smooth scroll behavior */
:root {
  scroll-behavior: smooth;
}

/*--------------------------------------------------------------
  # General
  --------------------------------------------------------------*/
.bg-color-transparent {
  background-color: rgba(92, 193, 128, 0.1);
}
.tracking-wider {
  letter-spacing: 0.5em;
}
.swiper-color {
  background-color: var(--text-pure-white);
}
.text-color {
  color: var(--text-color);
}
.text-darkblue {
  color: var(--text-darkblue);
}
.bg-color {
  background-color: var(--navbar-bg-color);
}
.primary {
  color: var(--color-primary);
}
.background-color {
  background-color: var(--background-color);
}

.btn-green {
  background-color: var(--color-primary);
  color: var(--text-pure-white);
  border: 2px solid var(--color-primary);
}
.btn-outline-green {
  background-color: var(--navbar-bg-color);
  color: var(--text-color);
  border: 2px solid var(--color-primary);
}
.btn-green:hover {
  background-color: var(--navbar-bg-color);
  color: var(--text-color);
  border: 2px solid var(--color-primary);
}
.btn-outline-green:hover {
  background-color: var(--color-primary);
  color: var(--text-pure-white);
  border: 2px solid var(--color-primary);
}
.image-event-wrapper img{
  height: 200px;
  width: 100%;
  object-fit: cover;
}
.image-event-wrapper{
  overflow: hidden;
}

.image-blog-wrapper img{
  height: 300px;
  width: 100%;
  object-fit: cover;
}
.image-blog-wrapper{
  overflow: hidden;
}

.image-height:hover {
  transform: scale(1.1);
}

body {
  overflow-x: hidden;
  font-family: var(--font-default);
  background-color: var(--background-color);
  color: var(--text-color);
}

a {
  color: var(--color-default);
  text-decoration: none;
}

a:hover {
  color: var(--color-white);
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: var(--font-primary);
}

/*--------------------------------------------------------------
  # Disable aos animation delay on mobile devices
  --------------------------------------------------------------*/
@media screen and (max-width: 768px) {
  [data-aos-delay] {
    transition-delay: 0 !important;
  }
}

/*--------------------------------------------------------------
  # Header
  --------------------------------------------------------------*/

.header {
  transition: all 0.5s;
  z-index: 997;
  background-color: var(--navbar-bg-color);
  height: 90px;
}

.header.sticked {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  height: 70px;
}

.header .logo img {
  max-height: 30px;
  margin-bottom: 6px;
  margin-right: 10px;
}

.header .logo h1 {
  font-size: 30px;
  margin: 0;
  font-weight: 600;
  letter-spacing: 0.8px;
  font-weight: bold;
  color: var(--text-color);
  font-family: var(--font-primary);
}

.sticked-header-offset {
  margin-top: 70px;
}

/*--------------------------------------------------------------
  # Desktop Navigation
  --------------------------------------------------------------*/
@media (min-width: 1200px) {
  .navbar {
    background-color: transparent;
    padding: 0;
  }

  .navbar ul {
    margin: 0;
    padding: 0;
    display: flex;
    list-style: none;
    align-items: center;
  }

  .navbar li {
    position: relative;
  }

  .navbar > ul > li {
    white-space: nowrap;
    padding: 10px 0 10px 28px;
  }

  .navbar a,
  .navbar a:focus {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 3px;
    font-family: var(--font-primary);
    font-size: 16px;
    font-weight: 600;
    /* color: var(--text-color); */
    white-space: nowrap;
    transition: 0.3s;
    position: relative;
  }

  .navbar a i,
  .navbar a:focus i {
    font-size: 12px;
    line-height: 0;
    margin-left: 5px;
  }

  .navbar > ul > li > a:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    bottom: -6px;
    left: 0;
    background-color: var(--color-secondary);
    visibility: hidden;
    width: 0px;
    transition: all 0.3s ease-in-out 0s;
  }

  .navbar a:hover:before,
  .navbar li:hover > a:before,
  .navbar .active:before {
    visibility: visible;
    width: 100%;
  }

  .navbar a:hover,
  .navbar .active,
  .navbar .active:focus,
  .navbar li:hover > a {
    color: #5bc17f;
  }

  .navbar .dropdown ul {
    display: block;
    position: absolute;
    left: 28px;
    top: calc(100% + 30px);
    margin: 0;
    padding: 10px 0;
    z-index: 99;
    opacity: 0;
    visibility: hidden;
    background: #fff;
    box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);
    transition: 0.3s;
    border-radius: 4px;
  }

  .navbar .dropdown ul li {
    min-width: 200px;
  }

  .navbar .dropdown ul a {
    padding: 10px 20px;
    font-size: 15px;
    text-transform: none;
    font-weight: 600;
    color: #5bc17f;
  }

  .navbar .dropdown ul a i {
    font-size: 12px;
  }

  .navbar .dropdown ul a:hover,
  .navbar .dropdown ul .active:hover,
  .navbar .dropdown ul li:hover > a {
    color: var(--color-secondary);
  }

  .navbar .dropdown:hover > ul {
    opacity: 1;
    top: 100%;
    visibility: visible;
  }

  .navbar .dropdown .dropdown ul {
    top: 0;
    left: calc(100% - 30px);
    visibility: hidden;
  }

  .navbar .dropdown .dropdown:hover > ul {
    opacity: 1;
    top: 0;
    left: 100%;
    visibility: visible;
  }
}

@media (min-width: 1200px) and (max-width: 1600px) {
  .navbar .dropdown .dropdown ul {
    left: -90%;
  }

  .navbar .dropdown .dropdown:hover > ul {
    left: -100%;
  }
}

@media (min-width: 1200px) {
  .mobile-nav-show,
  .mobile-nav-hide {
    display: none;
  }
}

/*--------------------------------------------------------------
  # Mobile Navigation
  --------------------------------------------------------------*/
@media (max-width: 1199px) {
  .navbar {
    position: fixed;
    top: 0;
    right: -100%;
    width: 100%;
    max-width: 400px;
    bottom: 0;
    transition: 0.3s;
    z-index: 9997;
  }

  .navbar ul {
    position: absolute;
    inset: 0;
    padding: 50px 0 10px 0;
    margin: 0;
    background: var(--background-color);
    overflow-y: auto;
    transition: 0.3s;
    z-index: 9998;
  }

  .navbar a,
  .navbar a:focus {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    font-family: var(--font-primary);
    font-size: 15px;
    font-weight: 600;
    color: var(--text-color);
    white-space: nowrap;
    transition: 0.3s;
  }

  .navbar a i,
  .navbar a:focus i {
    font-size: 12px;
    line-height: 0;
    margin-left: 5px;
  }

  .navbar a:hover,
  .navbar .active,
  .navbar .active:focus,
  .navbar li:hover > a {
    color: var(--color-primary);
  }
  .navbar .dropdown ul,
  .navbar .dropdown .dropdown ul {
    position: static;
    display: none;
    padding: 10px 0;
    margin: 10px 20px;
    transition: all 0.5s ease-in-out;
    background-color: var(--background-color-transparent);
    border: 1px solid var(--text-color);
  }

  .navbar .dropdown > .dropdown-active,
  .navbar .dropdown .dropdown > .dropdown-active {
    display: block;
  }

  .mobile-nav-show {
    color: var(--color-primary);
    font-size: 28px;
    cursor: pointer;
    line-height: 0;
    transition: 0.5s;
    z-index: 9999;
    margin-right: 10px;
  }

  .mobile-nav-hide {
    color: var(--text-color);
    font-size: 32px;
    cursor: pointer;
    line-height: 0;
    transition: 0.5s;
    position: fixed;
    right: 20px;
    top: 20px;
    z-index: 9999;
  }

  .mobile-nav-active {
    overflow: hidden;
  }

  .mobile-nav-active .navbar {
    right: 0;
  }

  .mobile-nav-active .navbar:before {
    content: "";
    position: fixed;
    inset: 0;
    background: var(--background-color-transparent);
    z-index: 9996;
  }
}

/*--------------------------------------------------------------
  # Hero Section
  --------------------------------------------------------------*/
#main-content {
  min-height: 90vh;
}
.animation {
  animation: animated-updown 2s ease-in-out infinite alternate-reverse both;
}

@keyframes animated-updown {
  0% {
    transform: translateY(8px);
  }

  100% {
    transform: translateY(-8px);
  }
}

/* about us */
.hero {
  width: 100%;
  position: relative;
  padding: 40px 0 20px 0;
}

.hero1 {
  width: 100%;
  position: relative;
  padding-top: 200px;
  padding-bottom: 200px;
}

.img-fluid {
  margin-left: 0px;
}

.hero1 h1 {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 20px;
  color: var(--text-color);
  line-height: 1.5;
}

.hero1 .btn-calculator i.bi-calculator {
  color: var(--color-primary);
}

.hero1 p {
  color: var(--text-color);
  font-weight: 400;
  margin-bottom: 35px;
  line-height: 1.9;
}

.hero1 .btn-get-started {
  font-family: var(--font-primary);
  font-weight: bold;
  font-size: 1em;
  /* display: inline-block; */
  padding: 14px 40px;
  border-radius: 50px;
  transition: 0.3s;
  color: var(--color-white);
  background: var(--color-primary);
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.08);
  border: 2px solid rgba(255, 255, 255, 0.1);
}

.hero1 .btn-get-started:hover {
  color: var(--color-primary);
  background: var(--background-color);
  border: 1px solid var(--color-primary);
}

.hero1 .my-custom-icon {
  color: #5bc17f;
}

.hero1 .btn-calculator {
  font-size: 16px;
  transition: 0.5s;
  padding: 14px 40px;
  border-radius: 50px;
  border: 1px solid var(--color-primary);
  margin-left: 25px;
  color: var(--color-primary);
  font-weight: 600;
}
.hero1 .btn-calculator:hover {
  color: var(--color-white);
  background-color: var(--color-primary);
}

.hero1 .btn-calculator i {
  color: var(--color-primary);
  font-size: 32px;
  transition: 0.3s;
  line-height: 0;
  margin-right: 8px;
}

.hero1 .btn-calculator:hover i {
  color: var(--color-white);
}

@media (max-width: 640px) {
  .hero1 h1 {
    font-size: 36px;
  }

  .hero1 .btn-get-started,
  .hero1 .btn-calculator {
    font-size: 0.8em;
    width: 100%;
    margin: 0px;
  }
  .button-wrapper {
    flex-direction: column;
    gap: 20px;
    justify-content: center;
  }
}

.hero1 .icon-boxes {
  padding-bottom: 60px;
}

@media (min-width: 1200px) {
  .hero1 .icon-boxes:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: calc(50% + 20px);
    background-color: #fff;
  }
}

.hero1 .icon-box {
  padding: 60px 30px;
  position: relative;
  overflow: hidden;
  background: #008d7d;
  box-shadow: 0 0 29px 0 rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease-in-out;
  border-radius: 8px;
  z-index: 1;
  height: 100%;
  width: 100%;
  text-align: center;
}

.hero1 .icon-box .title {
  font-weight: 700;
  margin-bottom: 15px;
  font-size: 24px;
}

.hero1 .icon-box .title a {
  color: #fff;
  transition: 0.3s;
}

.hero1 .icon-box .icon {
  margin-bottom: 20px;
  padding-top: 10px;
  display: inline-block;
  transition: all 0.3s ease-in-out;
  font-size: 48px;
  line-height: 1;
  color: rgba(255, 255, 255, 0.6);
}

.hero1 .icon-box:hover {
  background: #009786;
}

.hero1 .icon-box:hover .title a,
.hero1 .icon-box:hover .icon {
  color: #fff;
}

@media (min-width: 400px) {
  /* .hero1{
    padding-top: 50px;
    padding-bottom: 20px;
  } */

  .section-visi {
    padding: 0 0 0 0;
  }

  .section-header p {
      padding-bottom: 20px;
  }
}
/*--------------------------------------------------------------
  # Footer
  --------------------------------------------------------------*/
.footer {
  font-size: 14px;
  background-color: var(--footer-bg-color);
  padding: 50px 0;
  color: var(--text-pure-white);
}

.footer .footer-info .logo {
  line-height: 0;
  margin-bottom: 25px;
}

.footer .footer-info .logo img {
  max-height: 40px;
  margin-right: 6px;
}

.footer .footer-info .logo span {
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 1px;
  color: var(--text-pure-white);
  font-family: var(--font-primary);
}

.footer .footer-info p {
  padding-top: 10px;
  line-height: 30px;
  font-size: 14px;
  font-family: var(--font-primary);
}

.copyright {
  padding-top: 5px;
  line-height: 30px;
}

.footer .social-links a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid var(--text-pure-white);
  font-size: 16px;
  color: var(--text-pure-white);
  margin-right: 10px;
  transition: 0.3s;
}

.footer .social-links a:hover {
  color: var(--color-primary);
  border-color: #fff;
}

.footer h4 {
  font-size: 16px;
  font-weight: bold;
  position: relative;
  padding-bottom: 12px;
}

.footer .footer-links {
  margin-bottom: 30px;
}

.footer .footer-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer .footer-links ul i {
  padding-right: 2px;
  color: rgba(0, 131, 116, 0.8);
  font-size: 12px;
  line-height: 0;
}

.footer .footer-links ul li {
  padding: 10px 0;
  display: flex;
  align-items: center;
}

.footer .footer-links ul li:first-child {
  padding-top: 0;
}

.footer .footer-links ul a {
  color: var(--text-pure-white);
  transition: 0.3s;
  display: inline-block;
  line-height: 1;
}

.footer .footer-links ul a:hover {
  color: var(--color-primary);
}

.footer .footer-contact p {
  line-height: 26px;
}

.footer .credits {
  padding-top: 4px;
  text-align: left;
  font-size: 13px;
}

.footer .credits a {
  color: var(--text-pure-white);
}

.aktivitas-terbaru {
  font-weight: 700;
  font-size: 23px;
  line-height: 34px;
  color: var(--text-color);
}
.ellipse {
  width: 50px;
  height: 50px;
  background: #000000;
  border-radius: 50%;
  display: inline-block;
}
.text-light {
  color: #404040;
}

.stats-counter .stats-item i {
  font-size: 44px;
  line-height: 0;
  margin-right: 15px;
}

.stats-counter .stats-item span {
  font-size: 3rem;
  letter-spacing: 0.1em;
  display: block;
  font-weight: 700;
  color: var(--color-default);
  line-height: 40px;
}

.stats-counter .stats-item p {
  margin: 0;
  color: var(--color-default);
  font-size: 1em;
  font-weight: bold;
}

.vission {
  background-color: rgba(92, 193, 128, 0.1);
}

#future-events {
  /* background-color: rgba(92, 193, 128, 0.1); */
  /* margin-top: -50px; */
  padding-top: 50px;
  padding-bottom: 50px;
}

.stretched-link {
  text-decoration: none;
}
.stretched-link:hover {
  cursor: pointer;
  color: var(--text-color);
}

.button-readmore {
  outline: none;
  color: #5bc17f;
  border: 2px solid #5bc17f;
  padding: 15px 50px;
}
.button-readmore:hover {
  outline: none;
  background-color: #5bc17f;
  color: var(--background-color);
}

.partners .swiper {
  padding: 10px 0;
}

.partners .swiper-wrapper {
  height: auto;
}

.partners .swiper-slide img {
  transition: 0.3s;
  padding: 0 10px;
}

.partners .swiper-slide img:hover {
  transform: scale(1.1);
}

.breadcrumb-item.active,
.breadcrumb-item a,
.breadcrumb-item a:hover,
.breadcrumb-item + .breadcrumb-item::before {
  color: var(--text-color);
}

/* .scroll-top {
  position: fixed;
  visibility: hidden;
  opacity: 0;
  right: 15px;
  bottom: -15px;
  z-index: 99999;
  background: var(--text-color);
  width: 44px;
  height: 44px;
  border-radius: 50px;
  transition: all 0.4s;
}

.scroll-top i {
  font-size: 24px;
  color: var(--background-color);
  line-height: 0;
}

.scroll-top:hover {
  background: var(--text-color);
  color: var(--background-color);
}

.scroll-top.active {
  visibility: visible;
  opacity: 1;
  bottom: 15px;
} */

.custom-card1 {
  background-color: var(--custom-card1);
  border: none;
  border-radius: 1rem;
}
.custom-card2 {
  background-color: transparent;
  border: 2px solid #5cc180;;
}
.custom-card3 {
  background-color: var(--custom-card3);
  border: 2px solid #5cc180;;
}

.modal-header {
  background-color: var(--navbar-bg-color);
  color: var(--text-color);
}

.icon-th {
  font-size: 1.2rem; /* Adjust the icon size */
  margin-right: 5px; /* Adds spacing between the icon and text */
}

.modal-body {
  background-color: var(--background-color);
  color: var(--text-color);
}

.table-calculator {
  color: var(--text-color);
}

.bigger-img {
  width: 500px;
  height: 800px;
}

.btn1 {
  border: 2px solid #a6dab7;
  color: var(--text-color);
  border-radius: 1.5rem;
}
.btn1:hover {
  background-color: #6aea95;
}

/*--------------------------------------------------------------
# Sections & Section Header
--------------------------------------------------------------*/
section {
  overflow: hidden;
  scroll-margin-top: 70px;
  overflow: clip;
}

.text-center {
  padding-bottom: 30px;
}

.sections-bg {
  background-color: rgba(92, 193, 128, 0.1);
}

.section-header {
  text-align: center;
  padding-bottom: 30px;
}

.section-header h2 {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 20px;
  position: relative;
}

.section-header h2:after {
  content: "";
  position: absolute;
  display: block;
  width: 50px;
  height: 3px;
  background: var(--color-primary);
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.section-visi {
  text-align: left;
  padding-bottom: 60px;
}

.section-visi h2 {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 10px;
  padding-bottom: 20px;
  position: relative;
}

.section-visi h2:after {
  content: "";
  position: absolute;
  display: block;
  width: 50px;
  height: 3px;
  background: var(--color-primary);
  left: 0;
  right: 0;
  bottom: 0;
  margin-left: 5px;
}

.section-events {
  text-align: center;
}

.section-events h2 {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 10px;
  padding-bottom: 20px;
  position: relative;
}

.section-events h2:after {
  content: "";
  position: absolute;
  display: block;
  width: 50px;
  height: 3px;
  background: var(--color-primary);
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.kategori-impact {
  display: block;
  font-weight: 700;
  color: var(--color-primary);
  line-height: 40px;
}

.des-impact {
  padding-bottom: 50px;
}

.deskripsi-impact {
  padding-top: 10px;
  font-weight: 700;
  color: black;
  line-height: 40px;
}

.purecounter {
  font-size: 60px;
  padding-bottom: 20px;
}

.section-header p {
  color: #6f6f6f;
  line-height: 30px;
}

.section-events p {
  color: #6f6f6f;
  line-height: 30px;
}

.py-3late {
  background-color: rgba(92, 193, 128, 0.1);
}

.custom-img-event {
  max-height: 40vh;
  min-width: 100%;
  object-fit: cover;
}

.custom-img-up {
  width: 100%;
  top: 0;
  left: 0;
  margin: 0;
  box-shadow: 0px 2px 25px rgba(0, 0, 0, 0.2);
}

.custom-img {
  margin-top: 10px;
  width: 100%;
  box-shadow: 0px 2px 25px rgba(0, 0, 0, 0.2);
}

.col-lg-6 p {
  margin-bottom: 35px;
  text-align: justify;
  line-height: 30px;
  /* color: #6f6f6f; */
}

.col-lg-6 li {
  /* text-align: justify; */
  line-height: 30px;
  /* color: #6f6f6f; */
}

.paragraph {
  margin-top: 50px;
}

/*--------------------------------------------------------------
# Breadcrumbs
--------------------------------------------------------------*/
.breadcrumbs .page-header {
  padding: 60px 0 60px 0;
  min-height: 20vh;
  position: relative;
  background-color: var(--color-primary);
}

.breadcrumbs .page-header h2 {
  font-size: 56px;
  font-weight: 500;
  color: #fff;
  font-family: var(--font-secondary);
}

.breadcrumbs .page-header p {
  color: rgba(255, 255, 255, 0.8);
}

.breadcrumbs nav {
  background-color: rgba(92, 193, 128, 0.1);
  padding: 20px 0;
}

.breadcrumbs nav ol {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--color-default);
}

.breadcrumbs nav ol a {
  color: var(--color-primary);
  transition: 0.3s;
}

.breadcrumbs nav ol a:hover {
  text-decoration: underline;
}

.breadcrumbs nav ol li + li {
  padding-left: 10px;
}

.breadcrumbs nav ol li + li::before {
  display: inline-block;
  padding-right: 10px;
  color: var(--color-secondary);
  content: "/";
}

/*--------------------------------------------------------------
# Scroll top button
--------------------------------------------------------------*/
.scroll-top {
  position: fixed;
  visibility: hidden;
  opacity: 0;
  right: 15px;
  bottom: -15px;
  z-index: 99999;
  background: var(--color-third);
  width: 44px;
  height: 44px;
  border-radius: 50px;
  transition: all 0.4s;
}

.scroll-top i {
  font-size: 24px;
  color: #fff;
  line-height: 0;
}

.scroll-top.active {
  visibility: visible;
  opacity: 1;
  bottom: 15px;
}

/*--------------------------------------------------------------
# About Us Section
--------------------------------------------------------------*/
.about h3 {
  font-weight: 700;
  font-size: 28px;
  margin-bottom: 20px;
  font-family: var(--font-secondary);
}

.about .call-us {
  left: 10%;
  right: 10%;
  bottom: 0;
  background-color: #fff;
  box-shadow: 0px 2px 25px rgba(0, 0, 0, 0.08);
  padding: 20px;
  text-align: center;
}

.about .call-us h4 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 5px;
}

.about .call-us p {
  font-size: 28px;
  font-weight: 700;
  color: var(--color-primary);
}

.about .content ul {
  list-style: none;
  padding: 0;
}

.about .content ul li {
  padding: 0 0 10px 30px;
  position: relative;
}

.about .content ul i {
  position: absolute;
  font-size: 20px;
  left: 0;
  top: -3px;
  color: var(--color-primary);
}

.about .content p:last-child {
  margin-bottom: 0;
}

.play-btn {
  width: 94px;
  height: 94px;
  background: radial-gradient(var(--color-primary) 50%, rgba(0, 131, 116, 0.4) 52%);
  border-radius: 50%;
  display: block;
  position: absolute;
  left: calc(50% - 47px);
  top: calc(50% - 47px);
  overflow: hidden;
}

.play-btn:before {
  content: "";
  position: absolute;
  width: 120px;
  height: 120px;
  animation-delay: 0s;
  animation: pulsate-btn 2s;
  animation-direction: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: steps;
  opacity: 1;
  border-radius: 50%;
  border: 5px solid rgba(0, 131, 116, 0.7);
  top: -15%;
  left: -15%;
  background: rgba(198, 16, 0, 0);
}

.play-btn:after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-40%) translateY(-50%);
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 15px solid #fff;
  z-index: 100;
  transition: all 400ms cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

.play-btn:hover:before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-40%) translateY(-50%);
  width: 0;
  height: 0;
  border: none;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 15px solid #fff;
  z-index: 200;
  animation: none;
  border-radius: 0;
}

.play-btn:hover:after {
  border-left: 15px solid var(--color-primary);
  transform: scale(20);
}

@keyframes pulsate-btn {
  0% {
    transform: scale(0.6, 0.6);
    opacity: 1;
  }

  100% {
    transform: scale(1, 1);
    opacity: 0;
  }
}

/*--------------------------------------------------------------
# Stats Counter Section
--------------------------------------------------------------*/
.stats-counter {
  padding: 40px 0;
  /* background-color: rgba(92, 193, 128, 0.1); */
}

.stats-counter .stats-item {
  padding: 20px 0;
  border-bottom: 1px solid #e4e4e4;
}

.stats-counter .stats-item .purecounter {
  min-width: 90px;
  padding-right: 15px;
}

.stats-counter .stats-item i {
  font-size: 44px;
  line-height: 0;
  margin-right: 15px;
}

.stats-counter .stats-item span {
  font-size: 40px;
  display: block;
  font-weight: 700;
  color: var(--color-primary);
  line-height: 40px;
}

.stats-counter .stats-item p {
  margin: 0;
  font-family: var(--font-primary);
  font-size: 14px;
  padding-bottom: 20px;
}

/*--------------------------------------------------------------
# gallery Section
--------------------------------------------------------------*/
.gallery .gallery-flters {
  padding: 0 0 20px 0;
  margin: 0 auto;
  list-style: none;
  text-align: center;
}

.gallery .gallery-flters li {
  cursor: pointer;
  display: inline-block;
  padding: 0;
  font-size: 18px;
  font-weight: 500;
  margin: 0 10px;
  line-height: 1;
  transition: all 0.3s ease-in-out;
}

.gallery .gallery-flters li:hover,
.gallery .gallery-flters li.filter-active {
  color: var(--color-primary);
}

.gallery .gallery-flters li:first-child {
  margin-left: 0;
}

.gallery .gallery-flters li:last-child {
  margin-right: 0;
}

@media (max-width: 575px) {
  .gallery .gallery-flters li {
    font-size: 14px;
    margin: 0 5px;
  }
}

.gallery .gallery-wrap {
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  max-height: 250px;
  overflow: hidden;
}

.gallery .gallery-wrap img {
  transition: 0.3s;
  position: relative;
  z-index: 1;
  height: 250px;
  object-fit: cover;
}

.gallery .gallery-wrap .gallery-info {
  padding: 25px 20px;
  background-color: #fff;
  position: relative;
  border-top: 1px solid #f3f3f3;
  z-index: 2;
}

.gallery .gallery-wrap .gallery-info h4 {
  font-size: 18px;
  font-weight: 600;
  padding-right: 50px;
}

.gallery .gallery-wrap .gallery-info h4 a {
  color: var(--color-default);
  transition: 0.3s;
}

.gallery .gallery-wrap .gallery-info p {
  color: #6c757d;
  font-size: 14px;
  margin-bottom: 0;
  padding-right: 50px;
}

.gallery .gallery-wrap:hover img {
  transform: scale(1.1);
}

/*--------------------------------------------------------------
# Our Team Section
--------------------------------------------------------------*/
.team .member {
  margin: auto;
  text-align: center;
  background: #fff;
  border-radius: 10px;
  padding: 15px;
  overflow: hidden;
  box-shadow: 0px 2px 25px rgba(0, 0, 0, 0.1);
}

.team .member img {
  border-radius: 10px;
  width: 300px;
  height: 400px;
  object-fit: cover;
  overflow: hidden;
}

.team .member .member-content {
  padding: 0 20px 30px 20px;
}

.team .member h4 {
  font-weight: 700;
  color: black;
  margin-top: 16px;
  margin-bottom: 2px;
  font-size: 20px;
}

.team .member span {
  font-style: italic;
  display: block;
  font-size: 14px;
  color: #6c757d;
}

.team .member p {
  padding-top: 10px;
  font-size: 14px;
  font-style: italic;
  color: #6c757d;
}

.team .member .social {
  margin-top: 15px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.team .member .social a {
  color: #a2a2a2;
  transition: 0.3s;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #bbbbbb;
}

.team .member .social a:hover {
  color: var(--color-primary);
  border-color: var(--color-primary);
}

.team .member .social i {
  font-size: 18px;
  margin: 0 2px;
}

/* detail blogs */
.img-container {
  margin-top: -15vh;
}
.img-container img {
  min-width: 90%;
  max-height: 70vh;
  object-fit: cover;
}
.content-detail-blog p {
  text-align: justify;
}

`, "",{"version":3,"sources":["webpack://./src/public/css/style.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE;sBACoB;EACpB,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA,WAAW;AACX,yBAAyB;AACzB;EACE,wBAAwB;EACxB,wBAAwB;EACxB,sCAAsC;EACtC,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;EACrB,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB,EAAE,QAAQ;EACjC,uBAAuB,EAAE,WAAW;EACpC,uBAAuB,EAAE,WAAW;EACpC,uBAAuB,EAAE,UAAU;EACnC,uBAAuB,EAAE,WAAW;EACpC,uBAAuB,EAAE,UAAU;AACrC;;AAEA,cAAc;AACd;EACE,wBAAwB;EACxB,wBAAwB;EACxB,sCAAsC;EACtC,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;EACrB,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB,EAAE,QAAQ;EACjC,uBAAuB,EAAE,WAAW;EACpC,uBAAuB,EAAE,WAAW;EACpC,uBAAuB,EAAE,UAAU;EACnC,uBAAuB,EAAE,WAAW;EACpC,uBAAuB,EAAE,UAAU;AACrC;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;AACzB;;AAEA;;iEAEiE;AACjE;EACE,yCAAyC;AAC3C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;EAC7B,sCAAsC;AACxC;AACA;EACE,wCAAwC;EACxC,wBAAwB;EACxB,sCAAsC;AACxC;AACA;EACE,wCAAwC;EACxC,wBAAwB;EACxB,sCAAsC;AACxC;AACA;EACE,sCAAsC;EACtC,6BAA6B;EAC7B,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;;;EAME,gCAAgC;AAClC;;AAEA;;iEAEiE;AACjE;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;;iEAEiE;;AAEjE;EACE,oBAAoB;EACpB,YAAY;EACZ,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;iEAEiE;AACjE;EACE;IACE,6BAA6B;IAC7B,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,OAAO;IACP,wCAAwC;IACxC,kBAAkB;IAClB,UAAU;IACV,mCAAmC;EACrC;;EAEA;;;IAGE,mBAAmB;IACnB,WAAW;EACb;;EAEA;;;;IAIE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,kDAAkD;IAClD,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,MAAM;IACN,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,MAAM;IACN,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;;iEAEiE;AACjE;EACE;IACE,eAAe;IACf,MAAM;IACN,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,sBAAsB;IACtB,SAAS;IACT,mCAAmC;IACnC,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;EACf;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;;;;IAIE,2BAA2B;EAC7B;EACA;;IAEE,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,gCAAgC;IAChC,qDAAqD;IACrD,mCAAmC;EACrC;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,2BAA2B;IAC3B,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,SAAS;IACT,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,eAAe;IACf,QAAQ;IACR,+CAA+C;IAC/C,aAAa;EACf;AACF;;AAEA;;iEAEiE;AACjE;EACE,gBAAgB;AAClB;AACA;EACE,yEAAyE;AAC3E;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,aAAa;AACb;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;EAChC,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,WAAW;IACX,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,wBAAwB;IACxB,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE;;;KAGG;;EAEH;IACE,gBAAgB;EAClB;;EAEA;MACI,oBAAoB;EACxB;AACF;AACA;;iEAEiE;AACjE;EACE,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA6BG;;AAEH;EACE,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB,EAAE,yBAAyB;EAC5C,iBAAiB,EAAE,2CAA2C;AAChE;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;;AAEA;;+DAE+D;AAC/D;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,MAAM;EACN,OAAO;EACP,SAAS;EACT,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;+DAE+D;AAC/D;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;;+DAE+D;AAC/D;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,4CAA4C;EAC5C,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,OAAO;EACP,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iFAAiF;EACjF,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,mCAAmC;EACnC,gCAAgC;EAChC,UAAU;EACV,kBAAkB;EAClB,wCAAwC;EACxC,SAAS;EACT,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,4CAA4C;EAC5C,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,qCAAqC;EACrC,4BAA4B;EAC5B,YAAY;EACZ,4DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,4CAA4C;EAC5C,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,kCAAkC;EAClC,qCAAqC;EACrC,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE;IACE,0BAA0B;IAC1B,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,UAAU;EACZ;AACF;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,oBAAoB;AACtB;;AAEA;;+DAE+D;AAC/D;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gCAAgC;AAClC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;+DAE+D;AAC/D;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB","sourcesContent":["/* Fonts */\n:root {\n  --font-default: \"Poppins\", system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\",\n    \"Noto Color Emoji\";\n  --font-primary: \"Poppins\", sans-serif;\n  --font-secondary: \"Montserrat\", sans-serif;\n}\n\n/* Colors */\n/* Default (Light Mode) */\n:root {\n  --color-default: #222222;\n  --color-primary: #5cc180;\n  --color-primary-transparent: #5cc18090;\n  --color-secondary: #f85a40;\n  --color-third: #2a6620;\n  --color-white: #fefefe;\n  --background-color: #fcfdff;\n  --background-color-transparent: #2e2e2e90;\n  --text-color: #18063c;\n  --text-darkblue: #18063c;\n  --text-pure-white: #fefefe;\n  --navbar-bg-color: #fefefe;\n  --footer-bg-color: #5cc180;\n  --custom-card1: #a6dbb7;\n  --custom-card2: #5cc180;\n  --custom-card3: #5bc17f4f;\n  --icon-color-1: #f44336; /* Red */\n  --icon-color-2: #9c27b0; /* Purple */\n  --icon-color-3: #3f51b5; /* Indigo */\n  --icon-color-4: #4caf50; /* Green */\n  --icon-color-5: #ff9800; /* Orange */\n  --icon-color-6: #795548; /* Brown */\n}\n\n/* Dark Mode */\nbody.dark-mode {\n  --color-default: #fefefe;\n  --color-primary: #5cc180;\n  --color-primary-transparent: #fefefe90;\n  --color-secondary: #f85a40;\n  --color-third: #203366;\n  --color-white: #222222;\n  --background-color: #111827;\n  --background-color-transparent: #fefefe90;\n  --text-color: #fefefe;\n  --text-darkblue: #fefefe;\n  --navbar-bg-color: #1f2937;\n  --footer-bg-color: #1f2937;\n  --custom-card1: #1f2937;\n  --custom-card2: #111827;\n  --custom-card3: transparent;\n  --icon-color-1: #f44336; /* Red */\n  --icon-color-2: #9c27b0; /* Purple */\n  --icon-color-3: #3f51b5; /* Indigo */\n  --icon-color-4: #4caf50; /* Green */\n  --icon-color-5: #ff9800; /* Orange */\n  --icon-color-6: #795548; /* Brown */\n}\n\n/* Smooth scroll behavior */\n:root {\n  scroll-behavior: smooth;\n}\n\n/*--------------------------------------------------------------\n  # General\n  --------------------------------------------------------------*/\n.bg-color-transparent {\n  background-color: rgba(92, 193, 128, 0.1);\n}\n.tracking-wider {\n  letter-spacing: 0.5em;\n}\n.swiper-color {\n  background-color: var(--text-pure-white);\n}\n.text-color {\n  color: var(--text-color);\n}\n.text-darkblue {\n  color: var(--text-darkblue);\n}\n.bg-color {\n  background-color: var(--navbar-bg-color);\n}\n.primary {\n  color: var(--color-primary);\n}\n.background-color {\n  background-color: var(--background-color);\n}\n\n.btn-green {\n  background-color: var(--color-primary);\n  color: var(--text-pure-white);\n  border: 2px solid var(--color-primary);\n}\n.btn-outline-green {\n  background-color: var(--navbar-bg-color);\n  color: var(--text-color);\n  border: 2px solid var(--color-primary);\n}\n.btn-green:hover {\n  background-color: var(--navbar-bg-color);\n  color: var(--text-color);\n  border: 2px solid var(--color-primary);\n}\n.btn-outline-green:hover {\n  background-color: var(--color-primary);\n  color: var(--text-pure-white);\n  border: 2px solid var(--color-primary);\n}\n.image-event-wrapper img{\n  height: 200px;\n  width: 100%;\n  object-fit: cover;\n}\n.image-event-wrapper{\n  overflow: hidden;\n}\n\n.image-blog-wrapper img{\n  height: 300px;\n  width: 100%;\n  object-fit: cover;\n}\n.image-blog-wrapper{\n  overflow: hidden;\n}\n\n.image-height:hover {\n  transform: scale(1.1);\n}\n\nbody {\n  overflow-x: hidden;\n  font-family: var(--font-default);\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n\na {\n  color: var(--color-default);\n  text-decoration: none;\n}\n\na:hover {\n  color: var(--color-white);\n  text-decoration: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: var(--font-primary);\n}\n\n/*--------------------------------------------------------------\n  # Disable aos animation delay on mobile devices\n  --------------------------------------------------------------*/\n@media screen and (max-width: 768px) {\n  [data-aos-delay] {\n    transition-delay: 0 !important;\n  }\n}\n\n/*--------------------------------------------------------------\n  # Header\n  --------------------------------------------------------------*/\n\n.header {\n  transition: all 0.5s;\n  z-index: 997;\n  background-color: var(--navbar-bg-color);\n  height: 90px;\n}\n\n.header.sticked {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 70px;\n}\n\n.header .logo img {\n  max-height: 30px;\n  margin-bottom: 6px;\n  margin-right: 10px;\n}\n\n.header .logo h1 {\n  font-size: 30px;\n  margin: 0;\n  font-weight: 600;\n  letter-spacing: 0.8px;\n  font-weight: bold;\n  color: var(--text-color);\n  font-family: var(--font-primary);\n}\n\n.sticked-header-offset {\n  margin-top: 70px;\n}\n\n/*--------------------------------------------------------------\n  # Desktop Navigation\n  --------------------------------------------------------------*/\n@media (min-width: 1200px) {\n  .navbar {\n    background-color: transparent;\n    padding: 0;\n  }\n\n  .navbar ul {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    list-style: none;\n    align-items: center;\n  }\n\n  .navbar li {\n    position: relative;\n  }\n\n  .navbar > ul > li {\n    white-space: nowrap;\n    padding: 10px 0 10px 28px;\n  }\n\n  .navbar a,\n  .navbar a:focus {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 3px;\n    font-family: var(--font-primary);\n    font-size: 16px;\n    font-weight: 600;\n    /* color: var(--text-color); */\n    white-space: nowrap;\n    transition: 0.3s;\n    position: relative;\n  }\n\n  .navbar a i,\n  .navbar a:focus i {\n    font-size: 12px;\n    line-height: 0;\n    margin-left: 5px;\n  }\n\n  .navbar > ul > li > a:before {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 2px;\n    bottom: -6px;\n    left: 0;\n    background-color: var(--color-secondary);\n    visibility: hidden;\n    width: 0px;\n    transition: all 0.3s ease-in-out 0s;\n  }\n\n  .navbar a:hover:before,\n  .navbar li:hover > a:before,\n  .navbar .active:before {\n    visibility: visible;\n    width: 100%;\n  }\n\n  .navbar a:hover,\n  .navbar .active,\n  .navbar .active:focus,\n  .navbar li:hover > a {\n    color: #5bc17f;\n  }\n\n  .navbar .dropdown ul {\n    display: block;\n    position: absolute;\n    left: 28px;\n    top: calc(100% + 30px);\n    margin: 0;\n    padding: 10px 0;\n    z-index: 99;\n    opacity: 0;\n    visibility: hidden;\n    background: #fff;\n    box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);\n    transition: 0.3s;\n    border-radius: 4px;\n  }\n\n  .navbar .dropdown ul li {\n    min-width: 200px;\n  }\n\n  .navbar .dropdown ul a {\n    padding: 10px 20px;\n    font-size: 15px;\n    text-transform: none;\n    font-weight: 600;\n    color: #5bc17f;\n  }\n\n  .navbar .dropdown ul a i {\n    font-size: 12px;\n  }\n\n  .navbar .dropdown ul a:hover,\n  .navbar .dropdown ul .active:hover,\n  .navbar .dropdown ul li:hover > a {\n    color: var(--color-secondary);\n  }\n\n  .navbar .dropdown:hover > ul {\n    opacity: 1;\n    top: 100%;\n    visibility: visible;\n  }\n\n  .navbar .dropdown .dropdown ul {\n    top: 0;\n    left: calc(100% - 30px);\n    visibility: hidden;\n  }\n\n  .navbar .dropdown .dropdown:hover > ul {\n    opacity: 1;\n    top: 0;\n    left: 100%;\n    visibility: visible;\n  }\n}\n\n@media (min-width: 1200px) and (max-width: 1600px) {\n  .navbar .dropdown .dropdown ul {\n    left: -90%;\n  }\n\n  .navbar .dropdown .dropdown:hover > ul {\n    left: -100%;\n  }\n}\n\n@media (min-width: 1200px) {\n  .mobile-nav-show,\n  .mobile-nav-hide {\n    display: none;\n  }\n}\n\n/*--------------------------------------------------------------\n  # Mobile Navigation\n  --------------------------------------------------------------*/\n@media (max-width: 1199px) {\n  .navbar {\n    position: fixed;\n    top: 0;\n    right: -100%;\n    width: 100%;\n    max-width: 400px;\n    bottom: 0;\n    transition: 0.3s;\n    z-index: 9997;\n  }\n\n  .navbar ul {\n    position: absolute;\n    inset: 0;\n    padding: 50px 0 10px 0;\n    margin: 0;\n    background: var(--background-color);\n    overflow-y: auto;\n    transition: 0.3s;\n    z-index: 9998;\n  }\n\n  .navbar a,\n  .navbar a:focus {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 20px;\n    font-family: var(--font-primary);\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--text-color);\n    white-space: nowrap;\n    transition: 0.3s;\n  }\n\n  .navbar a i,\n  .navbar a:focus i {\n    font-size: 12px;\n    line-height: 0;\n    margin-left: 5px;\n  }\n\n  .navbar a:hover,\n  .navbar .active,\n  .navbar .active:focus,\n  .navbar li:hover > a {\n    color: var(--color-primary);\n  }\n  .navbar .dropdown ul,\n  .navbar .dropdown .dropdown ul {\n    position: static;\n    display: none;\n    padding: 10px 0;\n    margin: 10px 20px;\n    transition: all 0.5s ease-in-out;\n    background-color: var(--background-color-transparent);\n    border: 1px solid var(--text-color);\n  }\n\n  .navbar .dropdown > .dropdown-active,\n  .navbar .dropdown .dropdown > .dropdown-active {\n    display: block;\n  }\n\n  .mobile-nav-show {\n    color: var(--color-primary);\n    font-size: 28px;\n    cursor: pointer;\n    line-height: 0;\n    transition: 0.5s;\n    z-index: 9999;\n    margin-right: 10px;\n  }\n\n  .mobile-nav-hide {\n    color: var(--text-color);\n    font-size: 32px;\n    cursor: pointer;\n    line-height: 0;\n    transition: 0.5s;\n    position: fixed;\n    right: 20px;\n    top: 20px;\n    z-index: 9999;\n  }\n\n  .mobile-nav-active {\n    overflow: hidden;\n  }\n\n  .mobile-nav-active .navbar {\n    right: 0;\n  }\n\n  .mobile-nav-active .navbar:before {\n    content: \"\";\n    position: fixed;\n    inset: 0;\n    background: var(--background-color-transparent);\n    z-index: 9996;\n  }\n}\n\n/*--------------------------------------------------------------\n  # Hero Section\n  --------------------------------------------------------------*/\n#main-content {\n  min-height: 90vh;\n}\n.animation {\n  animation: animated-updown 2s ease-in-out infinite alternate-reverse both;\n}\n\n@keyframes animated-updown {\n  0% {\n    transform: translateY(8px);\n  }\n\n  100% {\n    transform: translateY(-8px);\n  }\n}\n\n/* about us */\n.hero {\n  width: 100%;\n  position: relative;\n  padding: 40px 0 20px 0;\n}\n\n.hero1 {\n  width: 100%;\n  position: relative;\n  padding-top: 200px;\n  padding-bottom: 200px;\n}\n\n.img-fluid {\n  margin-left: 0px;\n}\n\n.hero1 h1 {\n  font-size: 48px;\n  font-weight: 700;\n  margin-bottom: 20px;\n  color: var(--text-color);\n  line-height: 1.5;\n}\n\n.hero1 .btn-calculator i.bi-calculator {\n  color: var(--color-primary);\n}\n\n.hero1 p {\n  color: var(--text-color);\n  font-weight: 400;\n  margin-bottom: 35px;\n  line-height: 1.9;\n}\n\n.hero1 .btn-get-started {\n  font-family: var(--font-primary);\n  font-weight: bold;\n  font-size: 1em;\n  /* display: inline-block; */\n  padding: 14px 40px;\n  border-radius: 50px;\n  transition: 0.3s;\n  color: var(--color-white);\n  background: var(--color-primary);\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.08);\n  border: 2px solid rgba(255, 255, 255, 0.1);\n}\n\n.hero1 .btn-get-started:hover {\n  color: var(--color-primary);\n  background: var(--background-color);\n  border: 1px solid var(--color-primary);\n}\n\n.hero1 .my-custom-icon {\n  color: #5bc17f;\n}\n\n.hero1 .btn-calculator {\n  font-size: 16px;\n  transition: 0.5s;\n  padding: 14px 40px;\n  border-radius: 50px;\n  border: 1px solid var(--color-primary);\n  margin-left: 25px;\n  color: var(--color-primary);\n  font-weight: 600;\n}\n.hero1 .btn-calculator:hover {\n  color: var(--color-white);\n  background-color: var(--color-primary);\n}\n\n.hero1 .btn-calculator i {\n  color: var(--color-primary);\n  font-size: 32px;\n  transition: 0.3s;\n  line-height: 0;\n  margin-right: 8px;\n}\n\n.hero1 .btn-calculator:hover i {\n  color: var(--color-white);\n}\n\n@media (max-width: 640px) {\n  .hero1 h1 {\n    font-size: 36px;\n  }\n\n  .hero1 .btn-get-started,\n  .hero1 .btn-calculator {\n    font-size: 0.8em;\n    width: 100%;\n    margin: 0px;\n  }\n  .button-wrapper {\n    flex-direction: column;\n    gap: 20px;\n    justify-content: center;\n  }\n}\n\n.hero1 .icon-boxes {\n  padding-bottom: 60px;\n}\n\n@media (min-width: 1200px) {\n  .hero1 .icon-boxes:before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: calc(50% + 20px);\n    background-color: #fff;\n  }\n}\n\n.hero1 .icon-box {\n  padding: 60px 30px;\n  position: relative;\n  overflow: hidden;\n  background: #008d7d;\n  box-shadow: 0 0 29px 0 rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease-in-out;\n  border-radius: 8px;\n  z-index: 1;\n  height: 100%;\n  width: 100%;\n  text-align: center;\n}\n\n.hero1 .icon-box .title {\n  font-weight: 700;\n  margin-bottom: 15px;\n  font-size: 24px;\n}\n\n.hero1 .icon-box .title a {\n  color: #fff;\n  transition: 0.3s;\n}\n\n.hero1 .icon-box .icon {\n  margin-bottom: 20px;\n  padding-top: 10px;\n  display: inline-block;\n  transition: all 0.3s ease-in-out;\n  font-size: 48px;\n  line-height: 1;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.hero1 .icon-box:hover {\n  background: #009786;\n}\n\n.hero1 .icon-box:hover .title a,\n.hero1 .icon-box:hover .icon {\n  color: #fff;\n}\n\n@media (min-width: 400px) {\n  /* .hero1{\n    padding-top: 50px;\n    padding-bottom: 20px;\n  } */\n\n  .section-visi {\n    padding: 0 0 0 0;\n  }\n\n  .section-header p {\n      padding-bottom: 20px;\n  }\n}\n/*--------------------------------------------------------------\n  # Footer\n  --------------------------------------------------------------*/\n.footer {\n  font-size: 14px;\n  background-color: var(--footer-bg-color);\n  padding: 50px 0;\n  color: var(--text-pure-white);\n}\n\n.footer .footer-info .logo {\n  line-height: 0;\n  margin-bottom: 25px;\n}\n\n.footer .footer-info .logo img {\n  max-height: 40px;\n  margin-right: 6px;\n}\n\n.footer .footer-info .logo span {\n  font-size: 30px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  color: var(--text-pure-white);\n  font-family: var(--font-primary);\n}\n\n.footer .footer-info p {\n  padding-top: 10px;\n  line-height: 30px;\n  font-size: 14px;\n  font-family: var(--font-primary);\n}\n\n.copyright {\n  padding-top: 5px;\n  line-height: 30px;\n}\n\n.footer .social-links a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid var(--text-pure-white);\n  font-size: 16px;\n  color: var(--text-pure-white);\n  margin-right: 10px;\n  transition: 0.3s;\n}\n\n.footer .social-links a:hover {\n  color: var(--color-primary);\n  border-color: #fff;\n}\n\n.footer h4 {\n  font-size: 16px;\n  font-weight: bold;\n  position: relative;\n  padding-bottom: 12px;\n}\n\n.footer .footer-links {\n  margin-bottom: 30px;\n}\n\n.footer .footer-links ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.footer .footer-links ul i {\n  padding-right: 2px;\n  color: rgba(0, 131, 116, 0.8);\n  font-size: 12px;\n  line-height: 0;\n}\n\n.footer .footer-links ul li {\n  padding: 10px 0;\n  display: flex;\n  align-items: center;\n}\n\n.footer .footer-links ul li:first-child {\n  padding-top: 0;\n}\n\n.footer .footer-links ul a {\n  color: var(--text-pure-white);\n  transition: 0.3s;\n  display: inline-block;\n  line-height: 1;\n}\n\n.footer .footer-links ul a:hover {\n  color: var(--color-primary);\n}\n\n.footer .footer-contact p {\n  line-height: 26px;\n}\n\n.footer .credits {\n  padding-top: 4px;\n  text-align: left;\n  font-size: 13px;\n}\n\n.footer .credits a {\n  color: var(--text-pure-white);\n}\n\n.aktivitas-terbaru {\n  font-weight: 700;\n  font-size: 23px;\n  line-height: 34px;\n  color: var(--text-color);\n}\n.ellipse {\n  width: 50px;\n  height: 50px;\n  background: #000000;\n  border-radius: 50%;\n  display: inline-block;\n}\n.text-light {\n  color: #404040;\n}\n\n.stats-counter .stats-item i {\n  font-size: 44px;\n  line-height: 0;\n  margin-right: 15px;\n}\n\n.stats-counter .stats-item span {\n  font-size: 3rem;\n  letter-spacing: 0.1em;\n  display: block;\n  font-weight: 700;\n  color: var(--color-default);\n  line-height: 40px;\n}\n\n.stats-counter .stats-item p {\n  margin: 0;\n  color: var(--color-default);\n  font-size: 1em;\n  font-weight: bold;\n}\n\n.vission {\n  background-color: rgba(92, 193, 128, 0.1);\n}\n\n#future-events {\n  /* background-color: rgba(92, 193, 128, 0.1); */\n  /* margin-top: -50px; */\n  padding-top: 50px;\n  padding-bottom: 50px;\n}\n\n.stretched-link {\n  text-decoration: none;\n}\n.stretched-link:hover {\n  cursor: pointer;\n  color: var(--text-color);\n}\n\n.button-readmore {\n  outline: none;\n  color: #5bc17f;\n  border: 2px solid #5bc17f;\n  padding: 15px 50px;\n}\n.button-readmore:hover {\n  outline: none;\n  background-color: #5bc17f;\n  color: var(--background-color);\n}\n\n.partners .swiper {\n  padding: 10px 0;\n}\n\n.partners .swiper-wrapper {\n  height: auto;\n}\n\n.partners .swiper-slide img {\n  transition: 0.3s;\n  padding: 0 10px;\n}\n\n.partners .swiper-slide img:hover {\n  transform: scale(1.1);\n}\n\n.breadcrumb-item.active,\n.breadcrumb-item a,\n.breadcrumb-item a:hover,\n.breadcrumb-item + .breadcrumb-item::before {\n  color: var(--text-color);\n}\n\n/* .scroll-top {\n  position: fixed;\n  visibility: hidden;\n  opacity: 0;\n  right: 15px;\n  bottom: -15px;\n  z-index: 99999;\n  background: var(--text-color);\n  width: 44px;\n  height: 44px;\n  border-radius: 50px;\n  transition: all 0.4s;\n}\n\n.scroll-top i {\n  font-size: 24px;\n  color: var(--background-color);\n  line-height: 0;\n}\n\n.scroll-top:hover {\n  background: var(--text-color);\n  color: var(--background-color);\n}\n\n.scroll-top.active {\n  visibility: visible;\n  opacity: 1;\n  bottom: 15px;\n} */\n\n.custom-card1 {\n  background-color: var(--custom-card1);\n  border: none;\n  border-radius: 1rem;\n}\n.custom-card2 {\n  background-color: transparent;\n  border: 2px solid #5cc180;;\n}\n.custom-card3 {\n  background-color: var(--custom-card3);\n  border: 2px solid #5cc180;;\n}\n\n.modal-header {\n  background-color: var(--navbar-bg-color);\n  color: var(--text-color);\n}\n\n.icon-th {\n  font-size: 1.2rem; /* Adjust the icon size */\n  margin-right: 5px; /* Adds spacing between the icon and text */\n}\n\n.modal-body {\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n\n.table-calculator {\n  color: var(--text-color);\n}\n\n.bigger-img {\n  width: 500px;\n  height: 800px;\n}\n\n.btn1 {\n  border: 2px solid #a6dab7;\n  color: var(--text-color);\n  border-radius: 1.5rem;\n}\n.btn1:hover {\n  background-color: #6aea95;\n}\n\n/*--------------------------------------------------------------\n# Sections & Section Header\n--------------------------------------------------------------*/\nsection {\n  overflow: hidden;\n  scroll-margin-top: 70px;\n  overflow: clip;\n}\n\n.text-center {\n  padding-bottom: 30px;\n}\n\n.sections-bg {\n  background-color: rgba(92, 193, 128, 0.1);\n}\n\n.section-header {\n  text-align: center;\n  padding-bottom: 30px;\n}\n\n.section-header h2 {\n  font-size: 32px;\n  font-weight: 600;\n  margin-bottom: 20px;\n  padding-bottom: 20px;\n  position: relative;\n}\n\n.section-header h2:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  width: 50px;\n  height: 3px;\n  background: var(--color-primary);\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n}\n\n.section-visi {\n  text-align: left;\n  padding-bottom: 60px;\n}\n\n.section-visi h2 {\n  font-size: 32px;\n  font-weight: 600;\n  margin-bottom: 10px;\n  padding-bottom: 20px;\n  position: relative;\n}\n\n.section-visi h2:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  width: 50px;\n  height: 3px;\n  background: var(--color-primary);\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin-left: 5px;\n}\n\n.section-events {\n  text-align: center;\n}\n\n.section-events h2 {\n  font-size: 32px;\n  font-weight: 600;\n  margin-bottom: 10px;\n  padding-bottom: 20px;\n  position: relative;\n}\n\n.section-events h2:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  width: 50px;\n  height: 3px;\n  background: var(--color-primary);\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n}\n\n.kategori-impact {\n  display: block;\n  font-weight: 700;\n  color: var(--color-primary);\n  line-height: 40px;\n}\n\n.des-impact {\n  padding-bottom: 50px;\n}\n\n.deskripsi-impact {\n  padding-top: 10px;\n  font-weight: 700;\n  color: black;\n  line-height: 40px;\n}\n\n.purecounter {\n  font-size: 60px;\n  padding-bottom: 20px;\n}\n\n.section-header p {\n  color: #6f6f6f;\n  line-height: 30px;\n}\n\n.section-events p {\n  color: #6f6f6f;\n  line-height: 30px;\n}\n\n.py-3late {\n  background-color: rgba(92, 193, 128, 0.1);\n}\n\n.custom-img-event {\n  max-height: 40vh;\n  min-width: 100%;\n  object-fit: cover;\n}\n\n.custom-img-up {\n  width: 100%;\n  top: 0;\n  left: 0;\n  margin: 0;\n  box-shadow: 0px 2px 25px rgba(0, 0, 0, 0.2);\n}\n\n.custom-img {\n  margin-top: 10px;\n  width: 100%;\n  box-shadow: 0px 2px 25px rgba(0, 0, 0, 0.2);\n}\n\n.col-lg-6 p {\n  margin-bottom: 35px;\n  text-align: justify;\n  line-height: 30px;\n  /* color: #6f6f6f; */\n}\n\n.col-lg-6 li {\n  /* text-align: justify; */\n  line-height: 30px;\n  /* color: #6f6f6f; */\n}\n\n.paragraph {\n  margin-top: 50px;\n}\n\n/*--------------------------------------------------------------\n# Breadcrumbs\n--------------------------------------------------------------*/\n.breadcrumbs .page-header {\n  padding: 60px 0 60px 0;\n  min-height: 20vh;\n  position: relative;\n  background-color: var(--color-primary);\n}\n\n.breadcrumbs .page-header h2 {\n  font-size: 56px;\n  font-weight: 500;\n  color: #fff;\n  font-family: var(--font-secondary);\n}\n\n.breadcrumbs .page-header p {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.breadcrumbs nav {\n  background-color: rgba(92, 193, 128, 0.1);\n  padding: 20px 0;\n}\n\n.breadcrumbs nav ol {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--color-default);\n}\n\n.breadcrumbs nav ol a {\n  color: var(--color-primary);\n  transition: 0.3s;\n}\n\n.breadcrumbs nav ol a:hover {\n  text-decoration: underline;\n}\n\n.breadcrumbs nav ol li + li {\n  padding-left: 10px;\n}\n\n.breadcrumbs nav ol li + li::before {\n  display: inline-block;\n  padding-right: 10px;\n  color: var(--color-secondary);\n  content: \"/\";\n}\n\n/*--------------------------------------------------------------\n# Scroll top button\n--------------------------------------------------------------*/\n.scroll-top {\n  position: fixed;\n  visibility: hidden;\n  opacity: 0;\n  right: 15px;\n  bottom: -15px;\n  z-index: 99999;\n  background: var(--color-third);\n  width: 44px;\n  height: 44px;\n  border-radius: 50px;\n  transition: all 0.4s;\n}\n\n.scroll-top i {\n  font-size: 24px;\n  color: #fff;\n  line-height: 0;\n}\n\n.scroll-top.active {\n  visibility: visible;\n  opacity: 1;\n  bottom: 15px;\n}\n\n/*--------------------------------------------------------------\n# About Us Section\n--------------------------------------------------------------*/\n.about h3 {\n  font-weight: 700;\n  font-size: 28px;\n  margin-bottom: 20px;\n  font-family: var(--font-secondary);\n}\n\n.about .call-us {\n  left: 10%;\n  right: 10%;\n  bottom: 0;\n  background-color: #fff;\n  box-shadow: 0px 2px 25px rgba(0, 0, 0, 0.08);\n  padding: 20px;\n  text-align: center;\n}\n\n.about .call-us h4 {\n  font-size: 24px;\n  font-weight: 700;\n  margin-bottom: 5px;\n}\n\n.about .call-us p {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--color-primary);\n}\n\n.about .content ul {\n  list-style: none;\n  padding: 0;\n}\n\n.about .content ul li {\n  padding: 0 0 10px 30px;\n  position: relative;\n}\n\n.about .content ul i {\n  position: absolute;\n  font-size: 20px;\n  left: 0;\n  top: -3px;\n  color: var(--color-primary);\n}\n\n.about .content p:last-child {\n  margin-bottom: 0;\n}\n\n.play-btn {\n  width: 94px;\n  height: 94px;\n  background: radial-gradient(var(--color-primary) 50%, rgba(0, 131, 116, 0.4) 52%);\n  border-radius: 50%;\n  display: block;\n  position: absolute;\n  left: calc(50% - 47px);\n  top: calc(50% - 47px);\n  overflow: hidden;\n}\n\n.play-btn:before {\n  content: \"\";\n  position: absolute;\n  width: 120px;\n  height: 120px;\n  animation-delay: 0s;\n  animation: pulsate-btn 2s;\n  animation-direction: forwards;\n  animation-iteration-count: infinite;\n  animation-timing-function: steps;\n  opacity: 1;\n  border-radius: 50%;\n  border: 5px solid rgba(0, 131, 116, 0.7);\n  top: -15%;\n  left: -15%;\n  background: rgba(198, 16, 0, 0);\n}\n\n.play-btn:after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-40%) translateY(-50%);\n  width: 0;\n  height: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-left: 15px solid #fff;\n  z-index: 100;\n  transition: all 400ms cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n\n.play-btn:hover:before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-40%) translateY(-50%);\n  width: 0;\n  height: 0;\n  border: none;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-left: 15px solid #fff;\n  z-index: 200;\n  animation: none;\n  border-radius: 0;\n}\n\n.play-btn:hover:after {\n  border-left: 15px solid var(--color-primary);\n  transform: scale(20);\n}\n\n@keyframes pulsate-btn {\n  0% {\n    transform: scale(0.6, 0.6);\n    opacity: 1;\n  }\n\n  100% {\n    transform: scale(1, 1);\n    opacity: 0;\n  }\n}\n\n/*--------------------------------------------------------------\n# Stats Counter Section\n--------------------------------------------------------------*/\n.stats-counter {\n  padding: 40px 0;\n  /* background-color: rgba(92, 193, 128, 0.1); */\n}\n\n.stats-counter .stats-item {\n  padding: 20px 0;\n  border-bottom: 1px solid #e4e4e4;\n}\n\n.stats-counter .stats-item .purecounter {\n  min-width: 90px;\n  padding-right: 15px;\n}\n\n.stats-counter .stats-item i {\n  font-size: 44px;\n  line-height: 0;\n  margin-right: 15px;\n}\n\n.stats-counter .stats-item span {\n  font-size: 40px;\n  display: block;\n  font-weight: 700;\n  color: var(--color-primary);\n  line-height: 40px;\n}\n\n.stats-counter .stats-item p {\n  margin: 0;\n  font-family: var(--font-primary);\n  font-size: 14px;\n  padding-bottom: 20px;\n}\n\n/*--------------------------------------------------------------\n# gallery Section\n--------------------------------------------------------------*/\n.gallery .gallery-flters {\n  padding: 0 0 20px 0;\n  margin: 0 auto;\n  list-style: none;\n  text-align: center;\n}\n\n.gallery .gallery-flters li {\n  cursor: pointer;\n  display: inline-block;\n  padding: 0;\n  font-size: 18px;\n  font-weight: 500;\n  margin: 0 10px;\n  line-height: 1;\n  transition: all 0.3s ease-in-out;\n}\n\n.gallery .gallery-flters li:hover,\n.gallery .gallery-flters li.filter-active {\n  color: var(--color-primary);\n}\n\n.gallery .gallery-flters li:first-child {\n  margin-left: 0;\n}\n\n.gallery .gallery-flters li:last-child {\n  margin-right: 0;\n}\n\n@media (max-width: 575px) {\n  .gallery .gallery-flters li {\n    font-size: 14px;\n    margin: 0 5px;\n  }\n}\n\n.gallery .gallery-wrap {\n  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  max-height: 250px;\n  overflow: hidden;\n}\n\n.gallery .gallery-wrap img {\n  transition: 0.3s;\n  position: relative;\n  z-index: 1;\n  height: 250px;\n  object-fit: cover;\n}\n\n.gallery .gallery-wrap .gallery-info {\n  padding: 25px 20px;\n  background-color: #fff;\n  position: relative;\n  border-top: 1px solid #f3f3f3;\n  z-index: 2;\n}\n\n.gallery .gallery-wrap .gallery-info h4 {\n  font-size: 18px;\n  font-weight: 600;\n  padding-right: 50px;\n}\n\n.gallery .gallery-wrap .gallery-info h4 a {\n  color: var(--color-default);\n  transition: 0.3s;\n}\n\n.gallery .gallery-wrap .gallery-info p {\n  color: #6c757d;\n  font-size: 14px;\n  margin-bottom: 0;\n  padding-right: 50px;\n}\n\n.gallery .gallery-wrap:hover img {\n  transform: scale(1.1);\n}\n\n/*--------------------------------------------------------------\n# Our Team Section\n--------------------------------------------------------------*/\n.team .member {\n  margin: auto;\n  text-align: center;\n  background: #fff;\n  border-radius: 10px;\n  padding: 15px;\n  overflow: hidden;\n  box-shadow: 0px 2px 25px rgba(0, 0, 0, 0.1);\n}\n\n.team .member img {\n  border-radius: 10px;\n  width: 300px;\n  height: 400px;\n  object-fit: cover;\n  overflow: hidden;\n}\n\n.team .member .member-content {\n  padding: 0 20px 30px 20px;\n}\n\n.team .member h4 {\n  font-weight: 700;\n  color: black;\n  margin-top: 16px;\n  margin-bottom: 2px;\n  font-size: 20px;\n}\n\n.team .member span {\n  font-style: italic;\n  display: block;\n  font-size: 14px;\n  color: #6c757d;\n}\n\n.team .member p {\n  padding-top: 10px;\n  font-size: 14px;\n  font-style: italic;\n  color: #6c757d;\n}\n\n.team .member .social {\n  margin-top: 15px;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n}\n\n.team .member .social a {\n  color: #a2a2a2;\n  transition: 0.3s;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #bbbbbb;\n}\n\n.team .member .social a:hover {\n  color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n.team .member .social i {\n  font-size: 18px;\n  margin: 0 2px;\n}\n\n/* detail blogs */\n.img-container {\n  margin-top: -15vh;\n}\n.img-container img {\n  min-width: 90%;\n  max-height: 70vh;\n  object-fit: cover;\n}\n.content-detail-blog p {\n  text-align: justify;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
